import React from 'react';

import type { AllSeriesItem } from '~/src/common/lean-back';
import { BaseCarousel, BaseCarouselComposerProps } from '~/src/components/carousels/BaseCarousel';
import { CarouselPlaceholder } from '~/src/components/carousels/CarouselPlaceholder';
import type { WithPlaceholder } from '~/src/components/carousels/types';
import { dimension, SeriesCard } from '~/src/components/LeanBack/common-components/SeriesCard';

type CarouselItem = AllSeriesItem;
type Props = BaseCarouselComposerProps<CarouselItem>;

type PlaceholderProps = Pick<Props, 'button'>;
const Placeholder: React.FC<PlaceholderProps> = ({ button }) => (
  <CarouselPlaceholder
    headerDimensions={{ headerHeight: 15, headerWidth: 230 }}
    cardDimension={dimension}
    noButton={button === null}
    data-test-percy-hidden
  />
);

export const SeriesCarousel: React.FC<Props> & WithPlaceholder<PlaceholderProps> = props => {
  const itemsCount = props.items?.length ?? 0;
  if (itemsCount === 0) {
    return null;
  }
  return (
    <BaseCarousel<CarouselItem>
      renderCard={cardProps => <SeriesCard item={cardProps.item} />}
      getReactKey={c => c.title}
      {...props}
    />
  );
};

SeriesCarousel.Placeholder = Placeholder;
